import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EngagementReportsForNro = lazy(() =>
  import("@scenes/EngagementReports/components/EngagementReportsList/EngagementReportsList").then((module) => ({
    default: module.EngagementReportsList,
  }))
);

export const dashboardEngagementReportsNRO: NavigationRoutingObject = {
  Component: EngagementReportsForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-reports-sidebar-pill-menu-option", "Engagement Reports"),
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "editReporting" });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("engagement", "Engagement")],
      description: t("previously-engagement", 'Previously "Engagement"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/engagement_reports/:appGroupId",
};
